import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import GiftButtons from '../giftButtons'
import { createLocalizedPath } from '../../../../utils/localizationHelpers'
import { Link } from 'react-router-dom'
import { MyGift } from '../../../../store/member/memberTypings'
import moment from 'moment-mini'
import './myVirtualGiftPopup.sass'

interface Props {
    setExternalState: React.Dispatch<boolean>
    virtualGift: MyGift
}

const MyVirtualGiftPopup = ({ setExternalState, virtualGift }: Props) => {
    const [t] = useTranslation()
    const [showAttachment, setShowAttachment] = useState(false)

    return (
        <div className={'fullscreenWrapper'} onClick={() => setExternalState(false)}>
            <div className={'modal-dialog'} onClick={(e) => e.stopPropagation()}>
                <img className={'giftImg'} src={virtualGift.image} />
                <GiftButtons
                    recipient={virtualGift.sender ? virtualGift.sender.nick : null}
                    giftId={virtualGift.id}
                    recipientId={virtualGift.sender ? virtualGift.sender.id : null}
                    giftStatus={virtualGift.status}
                />
                <div className={'userInfo'}>
                    <div className="avatar">
                        <div className="account__avatar">
                            <img
                                src={
                                    virtualGift.sender
                                        ? virtualGift.sender.avatar_url
                                        : require('./../../../../assets/404.png')
                                }
                                alt={''}
                            />
                            {virtualGift.sender && (
                                <div className={virtualGift.sender.is_online ? '_status _online' : '_status'}></div>
                            )}
                        </div>
                    </div>
                    <div className={'nickBlock'}>
                        {virtualGift.sender ? (
                            <Link
                                to={{ pathname: createLocalizedPath(`/profil/${virtualGift.sender.nick}`) }}
                                target={'_blank'}
                                className={'nick'}
                            >
                                {virtualGift.sender.nick}
                            </Link>
                        ) : (
                            <p>{t('anonymous')}</p>
                        )}
                        <div className={'date'}>{moment(virtualGift.date * 1000).format(t('time format'))}</div>
                    </div>
                </div>
                {virtualGift.attachment_image && (
                    <img
                        className={'giftAttachment'}
                        src={virtualGift.attachment_image}
                        onClick={() => setShowAttachment(true)}
                    />
                )}
                {virtualGift.comment && (
                    <div className={'giftMessage'} dangerouslySetInnerHTML={{ __html: virtualGift.comment }} />
                )}
            </div>
            {virtualGift.attachment_image && showAttachment && (
                <img
                    className={'fullscreenAttachment'}
                    src={virtualGift.attachment_image}
                    onClick={(e) => {
                        e.stopPropagation()
                        setShowAttachment(false)
                    }}
                />
            )}
            <div
                className={'closeButton'}
                onClick={(e) => {
                    e.stopPropagation()
                    showAttachment ? setShowAttachment(false) : setExternalState(false)
                }}
            />
        </div>
    )
}

export default MyVirtualGiftPopup
